// import React from 'react';
// import '../styles/knownfor.css';
// import card1 from '../../../../assets/company/aboutus/knownfor/card1.svg';
// import card2 from '../../../../assets/company/aboutus/knownfor/card2.svg';
// import card3 from '../../../../assets/company/aboutus/knownfor/card3.svg';
// import card4 from '../../../../assets/company/aboutus/knownfor/card4.svg';
// import card5 from '../../../../assets/company/aboutus/knownfor/card5.svg';

// const Reasons = () => {
//     return (
//         <section className="knownfors-section">
//             <h2 className="knownfors-title">
//                 We are known for
//             </h2>
//             <div className="knownfors-container">
//                 <div className="knownfor-card">
//                     <img src={card1} alt="Experience" className="knownfor-icon" />
//                     <h3 className="knownfor-title">Infrastructure & <br />Cloud Solutions</h3>
//                     <p className="knownfor-description">Designing, deploying, and managing resilient infrastructure tailored for scalability and security.</p>
//                 </div>
//                 <div className="knownfor-card">
//                     <img src={card2} alt="Expertise" className="knownfor-icon" />
//                     <h3 className="knownfor-title">Disaster Recovery<br />& Business<br />Continuity</h3>
//                     <p className="knownfor-description">Building robust solutions that safeguard enterprises against downtime and data loss.</p>
//                 </div>
//                 <div className="knownfor-card">
//                     <img src={card3} alt="Time & Money" className="knownfor-icon" />
//                     <h3 className="knownfor-title">Microsoft Solutions<br />Expertise</h3>
//                     <p className="knownfor-description">Delivering seamless integration, modernization, and productivity through Microsoft’s ecosystem.</p>
//                 </div>
//                 <div className="knownfor-card">
//                     <img src={card4} alt="Long Term Retention" className="knownfor-icon" />
//                     <h3 className="knownfor-title">Application Modernization</h3>
//                     <p className="knownfor-description">Transforming legacy applications into modern, scalable, and secure systems.</p>
//                 </div>
//                 <div className="knownfor-card">
//                     <img src={card5} alt="Engagement Model" className="knownfor-icon" />
//                     <h3 className="knownfor-title">ERP Solutions</h3>
//                     <p className="knownfor-description">Enabling businesses with powerful, affordable, and customizable ERP systems for smarter decision-making.</p>
//                 </div>
//             </div>
//         </section>
//     );
// };

// export default Reasons;















import React from 'react';
import { useNavigate } from 'react-router-dom'; // Assuming you use react-router for navigation
// import card5 from '../../../../assets/company/aboutus/knownfor/card5.svg';



import DaasIcon from '../../../../assets/company/aboutus/DaasIcon.svg';
import ApplicationModernizationIcon from '../../../../assets/company/aboutus/ApplicationModernizationIcon.svg';
import BackupDisasterIocn from '../../../../assets/company/aboutus/Backup&DisasterIocn.svg';
import SecureCloudIcons from '../../../../assets/company/aboutus/SecureCloudIcon.svg';
import EndpointIcon from '../../../../assets/company/aboutus/EndpointIcon.svg';
import Microsoft365Icon from '../../../../assets/company/aboutus/Microsoft365Icon.svg';
import '../styles/knownfor.css';

const Reasons = () => {
    // const navigate = useNavigate();

    const knownForData = [
        {
            id: 1,
            icon: EndpointIcon,
            title: "Endpoint Management & Security",
            link: "/services/endpoint",
            description: "Synectiks delivers an innovative all-in-one endpoint management and cyber protection platform built to secure today’s distributed workforce."
        },
        {
            id: 2,
            icon: BackupDisasterIocn,
            title: "Backup & Disaster Recovery",
            link: "/services/disaster",
            description: "Modern businesses require more than backups-they need resilience. We provide advanced services that protect workloads across environments."
        },
        {
            id: 3,
            icon: DaasIcon,
            title: "Desktop as a Service",
            link: "/services/daas",
            description: "Synectiks offers secure, fast, and cost-effective Desktop as a Service (DaaS) for organizations that need remote access without compromise."
        },
        {
            id: 4,
            icon: SecureCloudIcons,
            title: "Secure Cloud Hosting",
            link: "/services/infrastructure",
            description: "Enterprise-grade infrastructure with Zero Trust controls, segmentation, and MFA. Gain secure performance and predictable pricing."
        },
        {
            id: 5,
            icon: Microsoft365Icon,
            title: "Microsoft 365 Services",
            link: "/workplace/microsoft-365",
            description: "As a certified Microsoft Solutions Partner, we go beyond migrations-building secure, agile, AI-powered workplaces for the future."
        },
        {
            id: 6,
            icon: ApplicationModernizationIcon,
            title: "Application Modernization",
            link: "/solutions/application-development",
            description: "Synectiks modernizes legacy systems into scalable, cloud-ready digital platforms that fuel business growth and reduce waste."
        }
    ];

    return (
        <section className="knownfors-section">
            <h2 className="knownfors-title">We are known for</h2>
            <div className="knownfors-container">
                {knownForData.map((item) => (
                    <div className="knownfor-card" key={item.id}>
                        <img src={item.icon} alt={item.title} className="knownfor-icon" />
                        <h3 className="knownfor-title">{item.title}</h3>
                        <p className="knownfor-description">{item.description}</p>
                        {/* <button
                            className="knownfor-learn-more"
                            onClick={() => navigate(item.link)}
                        >
                            Learn More
                            <svg className="arrow-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </button> */}
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Reasons;